// extracted by mini-css-extract-plugin
export default {"heading":"FAQPage_heading__tW4sg","content":"FAQPage_content__347ZE"};